import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Avatar, Box, Button, Menu, MenuItem } from "@mui/material";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { path } from "src/constants/path";
import { logout } from "src/redux/slices/userDetails";
import { useAppSelector } from "src/redux/store";
import { CustomStyles, getStyles } from "src/styles/theme";
import { isAccessLocked } from "src/utils/accessLock";
import defaultStyles, { StylesClasses } from "./styles";

type UserInfoProps = {
  customStyles?: CustomStyles<StylesClasses>;
};

export const UserInfo = ({ customStyles }: UserInfoProps) => {
  const styles = getStyles<StylesClasses>(defaultStyles, customStyles);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const userInfo = useAppSelector((state) => state.root.user.data);
  const [arrowReverse, isArrowReverse] = useState(false);
  const dispatch = useDispatch();

  // When the app is access-locked (non-PSU entity before the deadline), the
  // whole UI is disabled via #root pointer-events. Re-enable this profile menu
  // so the user can still log out, but keep the other menu items disabled.
  const locked = isAccessLocked({
    isGCAEntity: userInfo?.isGCAEntity,
    gcaType: userInfo?.gcaType,
  });

  // function reverseArrow() {
  //   isArrowReverse(!arrowReverse);
  // }

  const navigate = useNavigate();

  return (
    <Box
      {...styles("wrapper")}
      sx={{ display: "flex", pointerEvents: locked ? "auto" : undefined }}
    >
      <Avatar src="/assets/images/logo2.png" alt="user" {...styles("avatar")} />
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        {...styles("name")}
      >
        {!!userInfo ? userInfo.firstName : ""}
        <KeyboardArrowDownIcon
          {...styles("dropDown", {
            fontSize: "30px",
            transform: arrowReverse ? "rotate(180deg)" : "rotate(0deg)",
          })}
        />
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem
          disabled={locked}
          onClick={() => {
            if (userInfo?.userType === "ORGANIZATION") {
              navigate(`/gca/view/${userInfo?.userId}`);
            } else {
              navigate(path.myProfile);
            }
            handleClose();
          }}
        >
          My Profile
        </MenuItem>
        <MenuItem
          disabled={locked}
          onClick={() => {
            navigate(path.changePassword);
            handleClose();
          }}
        >
          Change Password
        </MenuItem>
        <MenuItem
          onClick={() => {
            dispatch(logout());
            handleClose();
          }}
        >
          Logout
        </MenuItem>
      </Menu>
    </Box>
  );
};
